import {
  UnsupportedAttachmentPreviewProps,
  useMessageComposer,
} from 'stream-chat-react';

import { AttachmentChip } from 'src/features/channel/custom-attachments/AttachmentChip';

export const CustomAttachmentPreview = (
  props: UnsupportedAttachmentPreviewProps,
) => {
  const { attachment } = props;
  if (attachment.type === 'file_id') {
    return <FileAttachmentPreview {...props} />;
  } else return null;
};

const FileAttachmentPreview = (props: UnsupportedAttachmentPreviewProps) => {
  const { attachment } = props;
  const { attachmentManager } = useMessageComposer();

  const handleRemove = () => {
    if (attachment.localMetadata?.id) {
      attachmentManager.removeAttachments([attachment.localMetadata.id]);
    }
  };

  return (
    <AttachmentChip
      title={attachment.title}
      mimeType={attachment.mime_type}
      onClose={handleRemove}
      className="hover:bg-gray-150"
    />
  );
};
